import React from 'react';
import { Columns } from '@components/Columns';
import {
  AnimatableButton,
  AnimatableButtonMobile,
  BoxContainer,
  GettingStartedWrapper,
  HeroTextPairing,
  MobileCloudImage,
  SiteTemplateLeftBlock,
  TextBlockWrapper,
  StyledBox,
  VimeoWrapper,
} from '@sections/wedding-website/WWHeroSection/WWHeroSection.styles';
import { getCreateWeddingUrl } from '@utils/urlHelpers.util';
import { getRootUrl } from '@utils/urlHelpers.util';
import { VimeoVideo } from '@components/VimeoVideo';
import { useTranslation } from 'react-i18next';

interface HeroVideoSectionProps {
  page: MarcomPageName;
}

const sectionId = 'Wedding_Websites_Hero';

export const WWHeroSection: React.FC<HeroVideoSectionProps> = ({ page }) => {
  const { t } = useTranslation('weddingWebsitePage');
  const heroVideoSectionData = t('sections.heroVideo');

  return (
    <BoxContainer as="section" id={sectionId} paddingBottom={[0, 12, 0]}>
      <SiteTemplateLeftBlock>
        <VimeoWrapper>
          <VimeoVideo
            title={heroVideoSectionData.videoTitle}
            embedUrl={heroVideoSectionData.videoUrl}
            posterUrl={heroVideoSectionData.videoPosterUrl}
            background
            cover
            isEagerLoading
            posterOptimization="aggressive"
            alt="wedding-website-hero"
            fetchPriority="high"
          />
        </VimeoWrapper>
        <StyledBox>
          <TextBlockWrapper verticalAlign="center">
            <Columns.Column width={6} mobile="full">
              <MobileCloudImage
                src="wedding-website/hero/ww-mobile-hero-2.jpg"
                resizeWidth={600}
                alt="ww_hero_static"
                width="100%"
                height="500px"
                isEagerLoading
                optimization="default"
                fetchPriority="high"
              />
              <HeroTextPairing
                id="wedding_website_hero_text_block"
                title={heroVideoSectionData.title}
                titleVariant="hed56"
                titleColor="neutra6"
                body={heroVideoSectionData.content}
                bodyVariant="dek20"
                bodyColor="neutra5"
                paddingTop={[0, 0]}
                marginBottom={[7]}
                textAlign={['center', 'left']}
                alignment={['center', 'left']}
              />
              <GettingStartedWrapper>
                <AnimatableButton id="heroGetStarted" variant="primary" forwardedAs={'a'} href={getCreateWeddingUrl(page)}>
                  {heroVideoSectionData.getStarted}
                </AnimatableButton>
                <AnimatableButton id="heroFindACouple" variant="purpleTransparentBtn" forwardedAs={'a'} href={getRootUrl('/find')}>
                  {heroVideoSectionData.findAnEvent}
                </AnimatableButton>
                <AnimatableButtonMobile id="mobileHeroGetStarted" variant={'secondary'} forwardedAs={'a'} href={getCreateWeddingUrl(page)}>
                  {heroVideoSectionData.getStarted}
                </AnimatableButtonMobile>
              </GettingStartedWrapper>
            </Columns.Column>
          </TextBlockWrapper>
        </StyledBox>
      </SiteTemplateLeftBlock>
    </BoxContainer>
  );
};
